import { useCallback, useState } from 'preact/hooks'
import { Link } from 'react-router-dom'
import withStyles from './jss'
import { LogoutDialog } from './logout-button'

import Exit from '../icons/right-from-bracket-solid.svg'

function Header({ classes, paths }) {
  const loggedIn = localStorage.getItem('token') !== null

  const [isDialogVisible, setIsDialogVisible] = useState(false)
  const logout = useCallback(e => {
    e.preventDefault()
    setIsDialogVisible(true)
  }, [])
  const onLogoutClose = useCallback(() => setIsDialogVisible(false), [])

  return (
    <div className={classes.links}>
      <div>
        <img src='https://static.umdctf.io/logo-2025.png' />
        <div>UMDCTF 2025</div>
      </div>
      {paths.map(({ path, name, icon }) => (
        <Link key={path} to={path} className={classes.link}>
          <div className={classes.linkIcon}>{icon}</div>
          <div className={classes.linkTitle}>{name}</div>
        </Link>
      ))}
      {loggedIn && (
        <>
          <a href='#' className={classes.link} onClick={logout}>
            <div className={classes.linkIcon}>
              <Exit />
            </div>
            <div className={classes.linkTitle}>Log Out</div>
          </a>
          <LogoutDialog open={isDialogVisible} onClose={onLogoutClose} />
        </>
      )}
    </div>
  )
}

export default withStyles(
  {
    links: {
      width: '100%',
      height: '3.5rem',
      margin: '0 auto 0 auto',
      borderTop: '4px solid lightgray',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
      '& > div': {
        display: 'none',
      },
    },
    link: {
      position: 'relative',
      padding: '.6rem',
      '&:hover div:last-child': {
        display: 'block',
      },
      '&:focus-visible div:last-child': {
        display: 'block !important',
      },
    },
    linkIcon: {
      height: '1.7rem',
      width: '1.7rem',
    },
    linkTitle: {
      display: 'none',
      position: 'absolute',
      zIndex: 3,
      top: '-1.8rem',
      width: '6rem',
      left: '-1.75rem',
      borderRadius: '.25rem',
      textAlign: 'center',
      backgroundColor: 'white',
      color: 'black',
    },
  },
  Header
)
